import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Avatar } from '@producer/ui-kit';

import type { Task } from '../../../app/entities';
import { MultiSelectDropdown } from '../../../components/select-dropdown';
import { context } from '../../../app/context';

import styles from './task-subscribers.module.scss';
import { UserPlusIcon } from '../../../components/icons/user-plus.icon';

interface TaskSubscribersProps {
  task: Task;
}

export const TaskSubscribers: React.FC<TaskSubscribersProps> = observer(({ task }) => {
  const options = useMemo(
    () =>
      context.space.members.map((member) => ({
        label: member.fullName,
        value: member._id,
      })),
    [],
  );

  /**
   * Receive the selected subscriberId:
   * 1. If it's already in the subscribers list, it should be removed
   * 2. If it's not, it should be removed
   * @param subscriberId
   */
  const handleChange = (subscriberId: string) => {
    task.toggleSubscriber(subscriberId);
  };

  return (
    <MultiSelectDropdown
      title={'Change subscribers'}
      options={options}
      selectedOptions={task.subscribers.map((subscriber) => subscriber._id)}
      onValueChange={handleChange}
      trigger={() => (
        <div className={styles.container}>
          {task.subscribers.length ? (
            task.subscribers.map((subscriber) => (
              <Avatar src={subscriber.avatar} size="small" initials={subscriber.initials} />
            ))
          ) : (
            <div className={styles.placeholder}>
              <UserPlusIcon />
            </div>
          )}
        </div>
      )}
    />
  );
});
